"use strict";

exports.motyka = require('./similarities/motyka');
exports.squaredChord = require('./similarities/squaredChord');
exports.dice = require('./similarities/dice');
exports.jaccard = require('./similarities/jaccard');
exports.tanimoto = require('./similarities/tanimoto');
exports.kulczynski = require('./similarities/kulczynski');
exports.czekanowski = require('./similarities/czekanowski');
exports.intersection = require('./similarities/intersection');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/similarities.js
 ** module id = 75
 ** module chunks = 0
 **/